import AuthorizationManager from './authorization-manager';
import store from '@/store';
const defaultAuthorization = {
	policies: ['InternalSupportTech']
};

var createAuthorizationMiddleware = function(vuexNamespace) {
	return function(to, from, next) {
		store
			.dispatch(
				(vuexNamespace ? vuexNamespace + '/' : '') + 'oidcCheckAccess',
				to
			)
			.then(function(hasAccess) {
				if(to?.meta?.isPublic) {
					return next(true);
				}
				if (hasAccess) {
						var routeAuthorized = AuthorizationManager.validate(to.meta?.authorization || defaultAuthorization)
						var componentAuthorized = AuthorizationManager.validate(to.matched[0]?.components?.default?.authorization)
						next(routeAuthorized && componentAuthorized || '/access-denied');
					}
				}
			);
	};
};

export default createAuthorizationMiddleware;
